module.exports = __webpack_public_path__ + "img/20220411_130252.60f6bad5.jpg";